import { getIDFromUrl } from '@rossum/api-client';
import type { Annotation } from '@rossum/api-client/annotations';
import { useQueueWithWorkspace } from '../../queues/hooks/useQueueWithWorkspace';

/**
 * Workspace / queue names for the split-screen breadcrumb. Kept as a small
 * local hook rather than inlining the query chain in `SplitScreen`.
 */
export const useDocumentBreadcrumb = (annotation: Annotation | undefined) => {
  const queueId = annotation ? getIDFromUrl(annotation.queue) : undefined;

  const { queue, workspace, queueIsLoading, workspaceIsLoading } =
    useQueueWithWorkspace({ queueId });

  return {
    workspaceName: annotation ? workspace?.name : undefined,
    queueName: annotation ? queue?.name : undefined,
    isLoading: Boolean(annotation) && (queueIsLoading || workspaceIsLoading),
  };
};
